import React from 'react';
import { getMoodData } from '../../constants/moods';
import { prepareEntryHtmlForWebView, handleEntryContentLinkClick } from '../../utils/entryLinks';

function EntryCard({ entry, isToday, index, onEdit, onDelete, onOpenInDiary }) {
  const moodData = getMoodData(entry.mood);

  const handleCardClick = (e) => {
    // Don't trigger if clicking on action buttons or a link (links open externally)
    if (e.target.closest('.dashboard__entry-actions') ||
        e.target.closest('.dashboard__entry-edit') ||
        e.target.closest('.dashboard__entry-delete') ||
        e.target.closest('a[href]')) {
      return;
    }
    if (onOpenInDiary) {
      onOpenInDiary(entry);
    }
  };

  const handleEntryTextClick = (e) => {
    if (e.target.closest('a[href]')) {
      handleEntryContentLinkClick(e);
    }
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    onEdit(entry);
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    onDelete(entry.id);
  };

  return (
    <article 
      className={`dashboard__entry ${isToday ? 'dashboard__entry--today' : ''} ${onOpenInDiary ? 'dashboard__entry--clickable' : ''}`}
      style={{ animationDelay: `${index * 0.05}s` }}
      onClick={onOpenInDiary ? handleCardClick : undefined}
    >
      <div className="dashboard__entry-header">
        <div className="dashboard__entry-meta">
          <div 
            className="dashboard__entry-mood-badge"
            style={{ 
              backgroundColor: `${moodData.color}15`,
              color: moodData.color 
            }}
          >
            <span className="dashboard__entry-mood-icon">{moodData.icon}</span>
            <span className="dashboard__entry-mood-label">{moodData.label}</span>
          </div>
          <time className="dashboard__entry-date">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
            {entry.date}
            {isToday && <span className="dashboard__entry-today-badge">Today</span>}
          </time>
        </div>
        <div className="dashboard__entry-actions">
          <button 
            className="dashboard__entry-edit"
            onClick={handleEditClick}
            aria-label="Edit entry"
            title="Edit this entry"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
          </button>
          <button 
            className="dashboard__entry-delete"
            onClick={handleDeleteClick}
            aria-label="Delete entry"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
              <line x1="10" y1="11" x2="10" y2="17"/>
              <line x1="14" y1="11" x2="14" y2="17"/>
            </svg>
          </button>
        </div>
      </div>
      <div 
        className="dashboard__entry-text"
        dangerouslySetInnerHTML={{ __html: prepareEntryHtmlForWebView(entry.text) }}
        onClick={handleEntryTextClick}
        role="article"
      />
    </article>
  );
}

export default EntryCard;
